import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/components/app.layout.component';

export const routes: Routes = [
  {
    path: 'gameday/scoreboard',
      title: 'Scoreboard',
    loadComponent: () =>
      import('./pages/scoreboard/scoreboard.component').then((component) => component.ScoreboardComponent)
  },
  {
    path: 'public_scoreboard',
      title: 'Scoreboard',
    loadComponent: () =>
      import('./pages/scoreboard/scoreboard.component').then((component) => component.ScoreboardComponent)
  },
  {
    path: 'liveticker',
      title: 'Liveticker',
    loadComponent: () =>
      import('./pages/liveticker/liveticker.component').then((component) => component.LivetickerComponent)
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: 'mitgliedsantrag',
          title: 'membershipApplication.title',
        loadComponent: () =>
          import('./pages/membership-application/membership-application.component').then(
            (component) => component.MembershipApplicationComponent
          )
      },
      {
        path: 'kontowechsel/:token',
          title: 'bankAccountChange.title',
        loadComponent: () =>
          import('./pages/bank-account-change/bank-account-change.component').then(
            (component) => component.BankAccountChangeComponent
          )
      },
      {
        path: 'supporter-bleiben/:token',
          title: 'supporterOffer.title',
        loadComponent: () =>
          import('./pages/supporter-offer/supporter-offer.component').then(
            (component) => component.SupporterOfferComponent
          )
      },
      {
        path: '',
        redirectTo: 'mitgliedsantrag',
        pathMatch: 'full'
      }
    ]
  }
];
